import { useQuery } from '@tanstack/react-query';
import {
  getLatestPrice,
  getCandles,
  getIndicators,
  getVolume,
  getVolatility,
  getComparison,
  getShortSqueeze,
} from '../utils/api';
import type { TimeRange, IndicatorType, IndicatorPeriod } from '../types';

export const useLatestPrice = (refetchInterval: number = 60000) => {
  return useQuery({
    queryKey: ['latestPrice'],
    queryFn: getLatestPrice,
    refetchInterval,
  });
};

export const useCandles = (range: TimeRange) => {
  return useQuery({
    queryKey: ['candles', range],
    queryFn: () => getCandles(range),
    staleTime: 60000, // Increase to 60 seconds
    retry: 1, // Reduce retries
  });
};

export const useIndicators = (
  type: IndicatorType,
  period: IndicatorPeriod,
  range: TimeRange
) => {
  return useQuery({
    queryKey: ['indicators', type, period, range],
    queryFn: () => getIndicators(type, period, range),
    staleTime: 60000,
    retry: 1,
  });
};

export const useVolume = (range: TimeRange) => {
  return useQuery({
    queryKey: ['volume', range],
    queryFn: () => getVolume(range),
    staleTime: 60000,
    retry: 1,
  });
};

export const useVolatility = (range: TimeRange) => {
  return useQuery({
    queryKey: ['volatility', range],
    queryFn: () => getVolatility(range),
    staleTime: 60000,
    retry: 1,
  });
};

export const useComparison = (periods: string[]) => {
  return useQuery({
    queryKey: ['comparison', periods.join(',')],
    queryFn: () => getComparison(periods),
    staleTime: 120000, // 2 minutes
    retry: 1,
  });
};

export const useShortSqueeze = (refetchInterval: number = 60000) => {
  return useQuery({
    queryKey: ['shortSqueeze'],
    queryFn: getShortSqueeze,
    refetchInterval,
    staleTime: 60000,
    retry: 1,
  });
};
